import enviro from 'enviro';
import {
  FREE_ACCESS_AGENT_LISTING_IDS_PROD,
  FREE_ACCESS_AGENT_LISTING_IDS_QA,
} from '../constants/Agents';

export function getIsFreeAccessAgent(listingId: number) {
  const isQa = enviro.isQa();
  return isQa
    ? FREE_ACCESS_AGENT_LISTING_IDS_QA.includes(listingId)
    : FREE_ACCESS_AGENT_LISTING_IDS_PROD.includes(listingId);
}
